var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5,32.9h-71a2,2,0,0,1-2-2v-6a8,8,0,0,1,8-8h8.1V8.2a2,2,0,0,1,2-2.1h6.7a2,2,0,0,1,2,2.1v8.7H60.7V8.2a2,2,0,0,1,2-2.1h6.7a2,2,0,0,1,2,2.1v8.7h8.1a8,8,0,0,1,8,8v6A2,2,0,0,1,85.5,32.9Zm-71,5.4h71a2,2,0,0,1,2,2V83.8a8,8,0,0,1-8,8.1h-59a8,8,0,0,1-8-8.1V40.3A2,2,0,0,1,14.5,38.3Zm55.8,16-4.7-4.7a2.1,2.1,0,0,0-2.9,0L45,67.2l-7.7-7.8a1.9,1.9,0,0,0-2.8,0l-4.8,4.7a2.1,2.1,0,0,0,0,2.9L43.5,80.9a2.1,2.1,0,0,0,2.9,0L70.3,57.2a2.1,2.1,0,0,0,0-2.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar-check.0ad86d40.svg";
export { ForwardRef as ReactComponent };